/* Pre-order quantity limit (only loaded when the theme setting is on).
 * caps = { variantId : can_sell }. Variants not in caps are untouched.
 * Cart line keys are "variantId:hash", so the cart page and the drawer use the same map.
 * Fails open: every handler is wrapped so an error leaves the normal theme behaviour. */
(function () {
  'use strict';

  if (window.PreorderLimit) return;
  var PL = (window.PreorderLimit = {});
  var caps = {};
  var msgs = {};

  function safe(fn) {
    return function (arg) {
      try {
        fn(arg);
      } catch (e) {
        /* fail open */
      }
    };
  }

  // ---------- Product page ----------

  // The theme resets disabled + label on every variant change before this runs,
  // so overriding here wins until the next variant change.
  function capProductForm(form, variantId) {
    var canSell = caps[variantId];
    var qty = form.querySelector('[name="quantity"]');

    // Sold out for pre-order: dynamic checkout buttons stop too (styles in the snippet)
    form.classList.toggle('pol-soldout', canSell !== undefined && canSell <= 0);

    if (canSell === undefined) {
      if (qty) qty.removeAttribute('max');
      return;
    }

    if (qty) {
      if (canSell > 0) {
        qty.max = canSell;
        if (Number(qty.value) > canSell) qty.value = canSell;
      } else {
        qty.removeAttribute('max');
      }
    }

    if (canSell <= 0) {
      var soldOut = (window.theme && theme.strings && theme.strings.soldOut) || 'Sold out';
      var buttons = [].slice.call(form.querySelectorAll('[data-add-to-cart]'))
        .concat([].slice.call(document.querySelectorAll('[data-sticky-add-to-cart]')));
      buttons.forEach(function (btn) {
        btn.disabled = true;
        var label = btn.querySelector('[data-add-to-cart-text]');
        if (label) label.textContent = soldOut;
      });
    }
  }

  // Typed values and Enter-to-submit can get past the input's max attribute.
  function clampQuantity(form) {
    var idInput = form.querySelector('[name="id"]');
    var canSell = idInput ? caps[idInput.value] : undefined;
    var qty = form.querySelector('[name="quantity"]');
    if (qty && canSell > 0 && Number(qty.value) > canSell) qty.value = canSell;
  }

  function formFrom(node) {
    if (!node || !node.querySelector) return null;
    if (node.matches && node.matches('form.product-form')) return node;
    return node.querySelector('form.product-form');
  }

  function initProduct() {
    document.querySelectorAll('form.product-form').forEach(function (form) {
      var idInput = form.querySelector('[name="id"]');
      if (idInput) capProductForm(form, idInput.value);
    });

    document.addEventListener('theme:variant:change', safe(function (event) {
      var form = formFrom(event.target);
      if (!form || !event.detail || !event.detail.variant) return;
      capProductForm(form, String(event.detail.variant.id));
    }));

    document.addEventListener('change', safe(function (event) {
      var form = event.target.form;
      if (event.target.name === 'quantity' && form && form.classList.contains('product-form')) {
        clampQuantity(form);
      }
    }), true);

    document.addEventListener('submit', safe(function (event) {
      if (event.target.classList && event.target.classList.contains('product-form')) {
        clampQuantity(event.target);
      }
    }), true);
  }

  // ---------- Cart page and drawer ----------

  // Message goes in the same column as the quantity box and REMOVE link (stacked below them).
  function showCartMessage(input, limit, show) {
    var counter = input.closest('.cart__quantity-counter') || input;
    var item = input.closest('.cart__item');
    var column = counter.parentElement;
    if (!column) return;
    if (item) item.querySelectorAll('.pol-msg').forEach(function (old) { old.remove(); });
    counter.classList.toggle('pol-over', show);
    if (!show) return;

    var msg = document.createElement('p');
    var title = item && item.querySelector('.cart__item__title');

    if (limit > 0) {
      msg.className = 'pol-msg';
      msg.textContent = (msgs.only || 'Only __N__ left to pre-order').replace('__N__', limit);
      column.appendChild(msg);
    } else if (title) {
      // Sold out: message sits under the product title, left-aligned
      msg.className = 'pol-msg pol-msg--title';
      msg.textContent = msgs.soldOut || 'Sold out for pre-order.';
      title.insertAdjacentElement('afterend', msg);
    } else {
      msg.className = 'pol-msg';
      msg.textContent = msgs.soldOut || 'Sold out for pre-order.';
      column.appendChild(msg);
    }
  }

  function setCheckoutBlock(container, blocked) {
    container.classList.toggle('pol-blocked', blocked);
  }

  // Runs on load and after every cart re-render (theme:cart:change fires for the
  // cart page and the drawer, since both use the same cart-items build).
  function applyCart() {
    var blocked = false;

    document.querySelectorAll('input[data-id][name="updates[]"]').forEach(function (input) {
      var key = input.getAttribute('data-id');
      var variantId = key.split(':')[0];
      if (!(variantId in caps)) return;

      var limit = Math.max(0, caps[variantId]);
      var over = Number(input.value) > limit;
      input.max = limit; // native stepper (plus button) stops at the limit

      if (over) {
        blocked = true;
        // Setting 0 would remove the line, so only clamp when there is stock to keep.
        // Dispatching change lets the theme's own cart update run.
        if (limit > 0) {
          input.value = limit;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      // Highlight and message only while the line is over its limit; both clear once fixed
      showCartMessage(input, limit, over);
    });

    // Only touch checkout buttons we disabled ourselves; the theme may disable them for terms.
    document.querySelectorAll('button[name="checkout"]').forEach(function (btn) {
      if (blocked) {
        btn.disabled = true;
        btn.setAttribute('data-pol-disabled', '');
      } else if (btn.hasAttribute('data-pol-disabled')) {
        btn.disabled = false;
        btn.removeAttribute('data-pol-disabled');
      }
    });

    // Cart summary and drawer footer: checkout + express buttons greyed out while blocked
    document.querySelectorAll('[data-cart-checkout-buttons]').forEach(function (container) {
      setCheckoutBlock(container, blocked);
    });
  }

  function initCart() {
    applyCart();
    document.addEventListener('theme:cart:change', safe(applyCart));
  }

  // ---------- Init ----------

  safe(function () {
    var contexts = {};
    document.querySelectorAll('script[data-pol-data]').forEach(function (el) {
      var data = JSON.parse(el.textContent);
      Object.keys(data.caps || {}).forEach(function (id) {
        caps[id] = data.caps[id];
      });
      if (data.msgs) msgs = data.msgs;
      contexts[el.getAttribute('data-pol-context')] = true;
    });
    PL.caps = caps;

    if (contexts.product) initProduct();
    if (contexts.cart || contexts.drawer) initCart();
  })();
})();
